import { buildLink, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import { cleanList } from '../../commons/cleanList';
import { removeEmptyParagraphs } from '../../commons/preprocess-paragraphs';
import { buildDrupalImage } from '../Image';

function mapMegaTeaser(teaser: TeaserFragment) {
  return {
    key: 'MegaHighlightTeaser',
    input: {
      lead: teaser.lead,
      Image: buildDrupalImage(teaser.image, 'square_teaser'),
      title: teaser.title || '',
      Link: teaser.link?.url
        ? buildLink({ href: teaser.link.url })
        : buildLink({ href: '/' }),
    },
  };
}

export function mapMegaTeasers(
  input: MegaTeasersFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'MegaTeasers'> {
  return {
    key: 'MegaTeasers',
    input: {
      title: input.title || '',
      teasers:
        removeEmptyParagraphs(input.teasers)
          .filter(cleanList)
          .map(mapMegaTeaser)
          .map((v) => v.input) || [],
    },
  };
}
